import { z } from 'zod';

import { BankAccountNumber, BankRoutingNumber } from './BankAccount';
import { BorrowerId } from './BrandedIds';
import { zodBrandedUuid } from './utils/Zod';

export const RepayPayAccountInput = z.object({
  accountNumber: BankAccountNumber,
  routingNumber: BankRoutingNumber,
  accountType: z.enum(['checking', 'savings']),
  firstName: z.string(),
  lastName: z.string(),
  email: z.email(),
});

export type RepayPayAccountInput = z.infer<typeof RepayPayAccountInput>;

export const CreateRepayAccountInput = RepayPayAccountInput.extend({
  borrowerId: zodBrandedUuid<BorrowerId>(),
});

export type CreateRepayAccountInput = z.infer<typeof CreateRepayAccountInput>;
